"use client";
import { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // wichtig!
    });
  }, []);

  return (
    <>
      <div
        className={
          "flex flex-col gap-4 items-center px-4 py-20 overflow-hidden"
        }
      >
        <div className={"flex flex-row gap-4 w-full xl:w-2/3"}>
          <h2 className="font-bold text-3xl">AGB</h2>
        </div>
        <div className={"flex flex-col gap-4 w-full xl:w-2/3"}>
          <div>
            <h3 className="text-2xl mb-1">§ 1 Geltungsbereich</h3>
            <ol className="list-decimal list-inside">
              <li>
                Diese Verkaufsbedingungen gelten ausschließlich.
                Entgegenstehende oder von den Verkaufsbedingungen abweichende
                Bedingungen des Bestellers erkennen wir nur an, wenn wir
                ausdrücklich schriftlich der Geltung zustimmen. Sämtliche
                Vereinbarungen, die zwischen uns und dem Besteller im
                Zusammenhang mit der Ausführung des Vertrages getroffen werden,
                sind schriftlich niederzulegen.
              </li>
              <li>
                Diese Verkaufsbedingungen gelten auch für alle zukünftigen
                Geschäfte mit dem Besteller.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 2 Angebot</h3>
            <ol className="list-decimal list-inside">
              <li>
                Sofern die Bestellung als Angebot gemäß § 145 BGB anzusehen ist,
                können wir diese innerhalb von 3 Wochen annehmen.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 3 Überlassene Unterlagen</h3>
            <ol className="list-decimal list-inside">
              <li>
                An allen in Zusammenhang mit der Auftragserteilung dem Besteller
                überlassenen Unterlagen, wie z. B. Kalkulationen, Zeichnungen
                etc., behalten wir uns Eigentums- und Urheberrechte vor. Diese
                Unterlagen dürfen Dritten nicht zugänglich gemacht werden, es
                sei denn, wir erteilen dazu dem Besteller unsere ausdrückliche
                schriftliche Zustimmung.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 4 Preise und Zahlung</h3>
            <ol className="list-decimal list-inside">
              <li>
                Sofern nichts Gegenteiliges schriftlich vereinbart wird, gelten
                unsere Preise ab Werk ausschließlich Verpackung. Kosten der
                Verpackung werden gesondert in Rechnung gestellt.
              </li>
              <li>
                Der Abzug von Skonto ist nur bei schriftlicher besonderer
                Vereinbarung zulässig.
              </li>
              <li>
                Nicht eingeschlossen in unseren Preisen ist die gesetzliche
                Mehrwertsteuer. Sie wird jeweils gesondert in Rechnung gestellt.
              </li>
              <li>
                Sofern nichts anderes vereinbart wird, ist der Kaufpreis ohne
                Abzug innerhalb von 8 Tagen ab Rechnungsdatum zur Zahlung
                fällig. Sofern der Besteller in Zahlungsverzug kommt, werden
                Verzugszinsen in Höhe von 4 % über dem jeweiligen Diskontsatz
                der Deutschen Bundesbank p.a. berechnet. Die Geltendmachung
                eines höheren Verzugsschadens bleibt vorbehalten.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">
              § 5 Aufrechnung und Zurückbehaltungsrechte
            </h3>
            <ol className="list-decimal list-inside">
              <li>
                Dem Besteller steht das Recht zur Aufrechnung nur zu, wenn seine
                Gegenansprüche rechtskräftig festgestellt, unbestritten oder von
                uns anerkannt sind. Zur Ausübung eines Zurückbehaltungsrechts
                ist der Besteller nur insoweit befugt, als sein Gegenanspruch
                auf dem gleichen Vertragsverhältnis beruht.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 6 Lieferzeit</h3>
            <ol className="list-decimal list-inside">
              <li>
                Der Beginn der von uns angegebenen Lieferzeit setzt die
                Abklärung aller technischen Fragen sowie die rechtzeitige und
                ordnungsgemäße Erfüllung der Verpflichtungen des Bestellers
                voraus.
              </li>
              <li>
                Für den Fall, dass der Besteller in Annahmeverzug kommt oder
                sonstige Mitwirkungspflichten verletzt, sind wir berechtigt, den
                uns entstehenden Schaden, einschließlich etwaiger
                Mehraufwendungen zu verlangen. Im Fall des Annahmeverzugs geht
                die Gefahr eines zufälligen Untergangs oder einer zufälligen
                Verschlechterung der Kaufsache in dem Zeitpunkt auf den
                Besteller über, in dem dieser in Annahmeverzug gerät.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 7 Gefahrübergang</h3>
            <ol className="list-decimal list-inside">
              <li>
                Wird die Ware auf Wunsch des Käufers an diesen versandt, so geht
                mit der Absendung an den Besteller, spätestens mit Verlassen des
                Werks/Lagers die Gefahr des zufälligen Untergangs oder der
                zufälligen Verschlechterung der Ware auf den Besteller über.
                Dies gilt unabhängig davon, ob die Versendung der Ware vom
                Erfüllungsort erfolgt oder wer die Frachtkosten trägt.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 8 Eigentumsvorbehalt</h3>
            <ol className="list-decimal list-inside">
              <li>
                Wir behalten uns das Eigentum an der gelieferten Sache bis zur
                vollständigen Zahlung sämtlicher Forderungen aus dem
                Liefervertrag vor. Wir sind berechtigt, die Kaufsache
                zurückzunehmen, wenn der Besteller sich vertragswidrig verhält.
                In der Zurücknahme der Kaufsache liegt kein Rücktritt vom
                Vertrag, solange dies nicht ausdrücklich schriftlich erklärt
                ist.
              </li>
              <li>
                Der Besteller ist verpflichtet, solange das Eigentum noch nicht
                auf ihn übergegangen ist, die Kaufsache pfleglich zu behandeln.
                Insbesondere ist er verpflichtet, diese auf eigene Kosten gegen
                Diebstahl-, Feuer- und Wasserschäden ausreichend zum Neuwert zu
                versichern. Müssen Wartungs- und Inspektionsarbeiten
                durchgeführt werden, hat der Besteller diese auf eigene Kosten
                rechtzeitig auszuführen. Solange das Eigentum noch nicht
                übergegangen ist, hat uns der Besteller unverzüglich schriftlich
                zu benachrichtigen, wenn der gelieferte Gegenstand gepfändet
                oder sonstigen Eingriffen Dritter ausgesetzt ist. Soweit der
                Dritte nicht in der Lage ist, uns die gerichtlichen und
                außergerichtlichen Kosten einer Klage gemäß § 771 ZPO zu
                erstatten, haftet der Besteller für den uns entstandenen
                Ausfall.
              </li>
              <li>
                Der Besteller ist zur Weiterveräußerung der Vorbehaltsware im
                normalen Geschäftsverkehr berechtigt. Die Forderungen des
                Abnehmers aus der Weiterveräußerung der Vorbehaltsware tritt der
                Besteller schon jetzt an uns in Höhe des mit uns vereinbarten
                Faktur-Endbetrages (einschließlich Mehrwertsteuer) ab. Diese
                Abtretung gilt unabhängig davon, ob die Kaufsache ohne oder nach
                Verarbeitung weiterverkauft worden ist. Der Besteller bleibt zur
                Einziehung der Forderung auch nach der Abtretung ermächtigt.
                Unsere Befugnis, die Forderung selbst einzuziehen, bleibt davon
                unberührt. Wir werden jedoch die Forderung nicht einziehen,
                solange der Besteller seinen Zahlungsverpflichtungen aus den
                vereinnahmten Erlösen nachkommt, nicht in Zahlungsverzug ist und
                insbesondere kein Antrag auf Eröffnung eines Insolvenzverfahrens
                gestellt ist oder Zahlungseinstellung vorliegt.
              </li>
              <li>
                Die Verarbeitung oder Umbildung der Kaufsache durch den
                Besteller wird stets für uns vorgenommen. In diesem Fall setzt
                sich das Anwartschaftsrecht des Bestellers an der Kaufsache an
                der umgebildeten Sache fort. Sofern die Kaufsache mit anderen,
                uns nicht gehörenden Gegenständen verarbeitet wird, erwerben wir
                das Miteigentum an der neuen Sache im Verhältnis des objektiven
                Wertes unserer Kaufsache zu den anderen bearbeiteten
                Gegenständen zur Zeit der Verarbeitung. Dasselbe gilt für den
                Fall der Vermischung. Sofern die Vermischung in der Weise
                erfolgt, dass die Sache des Bestellers als Hauptsache anzusehen
                ist, gilt als vereinbart, dass der Besteller uns anteilmäßig
                Miteigentum überträgt und das so entstandene Alleineigentum oder
                Miteigentum für uns verwahrt.
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">§ 9 Mängelgewährleistung</h3>
            <ol className="list-decimal list-inside">
              <li>
                Gewährleistungsrechte des Bestellers setzen voraus, dass dieser
                seinen nach §§ 377, 378 HGB geschuldeten Untersuchungs- und
                Rügeobliegenheiten ordnungsgemäß nachgekommen ist.
              </li>
              <li>
                Soweit ein von uns zu vertretender Mangel der Kaufsache
                vorliegt, sind wir berechtigt, nach unserer Wahl den Mangel
                entweder zu beseitigen oder Ersatz zu liefern.
              </li>
              <li>
                Die Gewährleistungsfrist für nicht von uns entwickelten
                Produkten beträgt die vom Gesetzgeber vorgegebene Zeit,
                gerechnet ab Gefahrenübergang. Diese Frist gilt auch für
                Ansprüche auf Ersatz von Mangelfolgeschäden, soweit keine
                Ansprüche aus unerlaubter Handlung geltend gemacht werden.
              </li>
              <li>
                Die Gewährleistung für unsere Software wird in einer gesonderten
                Software AGB geregelt
              </li>
            </ol>
          </div>
          <div>
            <h3 className="text-2xl mb-1">
              § 10 Gerichtsstand und Erfüllungsort
            </h3>
            <ol className="list-decimal list-inside">
              <li>
                Sofern der Besteller Kaufmann ist, ist unser Geschäftssitz
                Gerichtsstand. Wir sind jedoch auch berechtigt, den Besteller an
                seinem Wohnsitzgericht zu verklagen. Unser Geschäftssitz ist
                Erfüllungsort. Abweichungen davon müssen schriftlich vereinbart
                werden.
              </li>
            </ol>
          </div>
          <div>
            <h2 className="text-3xl">Gesonderte AGB</h2>
          </div>
          <div>
            <h3 className="text-2xl mb-1">
              Haftung und Gewährleistung eigener Softwareentwicklung
            </h3>
            <p>
              Nach dem Stand der Technik ist es nicht möglich, Computersoftware
              so zu erstellen, dass sie in allen Anwendungen und Kombinationen
              fehlerfrei arbeitet. Gegenstand des Vertrages ist daher eine
              Software, die im Sinne der Programmbeschreibung und
              Bedienungsanleitung grundsätzlich brauchbar ist. Aus diesen
              genannten Gründen wird keinerlei Haftung für die Fehlerfreiheit
              der Software und eventueller dadurch entstandener Schäden
              übernommen. Der Lizenzgeber handelt nicht für entgangenen Gewinn.
              Der Lizenzgeber haftet nicht für die richtige Auswahl, Einsatz,
              Anwendung, und Nutzung der Software. Das gilt insbesondere für den
              Fall des Einsatzes nicht geeigneter Hardware oder Änderungen der
              Software. Insbesondere ist die Haftung für alle durch die Software
              verursachten mittelbaren Schäden ausgeschlossen, sofern dies
              gesetzlich zulässig ist. Der Lizenzgeber haftet nicht für
              Ansprüche auf Schadenersatz aus jedem Rechtsgrund, außer es kann
              vom Lizenznehmer grob fahrlässiges oder vorsätzliches Handeln, Tun
              oder Unterlassen nachgewiesen werden. Für Kaufleute wird auch die
              Haftung für grobe Fahrlässigkeit ausgeschlossen. Für den Fall,
              dass die Software dem Lizenznehmer auf einen Datenträger (i.d.R.
              auf CD-ROM) geliefert wird: Mängel am Datenträgermaterial, welche
              infolge eines vor der Lieferung liegenden Umstandes auftreten
              (z.B. Materialfehler), leistet der Lizenzgeber innerhalb der
              umseitig genannten Gewährleistungsfrist nach seiner Wahl durch
              Neulieferung Gewähr. Weitergehende Ansprüche sind ausgeschlossen.
              Ein verantwortungsvoller Umgang mit Daten verarbeitenden
              Programmen setzt einen gründlichen Test des Programms mit
              unkritischen Daten voraus, bevor es zum tatsächlichen Einsatz
              gelangt. Zu jedem Computer gehört ein Backupkonzept, welches
              gewährleistet, dass wichtige Daten in regelmäßigen Abständen auf
              externen Datenträgern gesichert werden. Für die Erstellung vom
              Backups der Datenbanken ist der Lizenznehmer verantworlich. Der
              Lizenzgeber übernimmt keine verantwortung für Verlust oder
              Beschädigung von Datenbanken und Backups
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Ausschluss der Gewährleistung</h3>
            <p>
              Für diese Software und die dazugehörigen Dateien wird keine
              Garantieleistung übernommen. Aufgrund der unterschiedlichen
              Hardware- und Softwareumgebungen, unter denen eine
              Software-Installation möglich ist, wird keine Gewährleistung für
              den Einsatz der Software zu einem speziellen Zweck übernommen. Der
              Anwender trägt selbst jedes Risiko.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Testphase</h3>
            <p>
              Bei dieser Art von Software handelt es sich um ein Standard
              Produkt mit Individualprogrammierung. Sollte Ihnen eine Testphase
              von 30 Tagen eingeräumt werden und nach diesem Zeitraum nicht
              käuflich erwerben, sind Sie verpflichtet, eine Nutzungsgebühr zu
              entrichten oder die Software zu deinstallieren. Das Verwenden
              einer nicht registrierten Version nach Ablauf der 30-tägigen Frist
              bedeutet eine Verletzung der internationalen
              Copyright-Bestimmungen.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Lizenzgewährung</h3>
            <p>
              Der Lizenzgeber gewährt Ihnen eine ausschließliche, nicht
              übertragbare Lizenz zur Installation der Software auf einem
              beliebigen einzelnen Personalcomputer bzw. zum Kopieren der
              Software einzig zu dem Zweck der Installation auf Ihrem Computer
              und als Sicherung und Archivaufbewahrung. Es ist verboten, Kopien
              der Software herzustellen, zu verkaufen, zu vermieten oder zu
              vertreiben. Es ist erlaubt, die Rechte dieses Vertrages an Dritte
              zu übertragen, vorausgesetzt, die dritte Partei erklärt sich
              schriftlich damit einverstanden, sich an die Vertragsbedingungen
              zu halten. In einem solchen Fall sind alle Kopien der Software an
              die dritte Partei zu übergeben. Alle nicht übergebenen Kopien sind
              zu vernichten. Sie sind dazu verpflichtet, den Dritten als neuen
              Lizenznehmer bei uns zu melden. Die Software darf nur den PC’s auf
              EINEM Computer installiert werden. Für den gleichzeitigen Einsatz
              der Software auf MEHREREN Computern oder in einem Netzwerk muss
              eine Mehrfach-Lizenz erworben werden. Der Lizenzgeber untersagt
              jeglichen Verleih der Software.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Keine weiteren Rechtsansprüche</h3>
            <p>
              Der Lizenzgeber ist sowohl Urheber als auch Eigentümer der
              Software ist. Der Lizenzgeber behält den Rechts- und
              Besitzanspruch der Software. Eine Lizenz ist kein Verkauf der
              Software. Der Lizenzvertrag gewährt Ihnen keinen Anspruch auf
              Patente, Vervielfältigungen, Branchengeheimnisse, Warenzeichen
              oder auf andere Rechte.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Urheberrecht</h3>
            <p>
              Die Software ist urheberrechtlich geschützt. Der Lizenzgeber macht
              darauf aufmerksam, dass der Lizenznehmer für alle Schäden aufgrund
              von Urheberrechtsverletzungen haftet. Eine bekannt werdende
              Urheberrechtsverletzung führt unweigerlich zur Anzeige.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">
              Keine Modifikationen oder Dekompilierung
            </h3>
            <p>
              ES IST VERBOTEN, DIE SOFTWARE, DIE DOKUMENTATION ODER KOPIEN IM
              GANZEN ODER TEILWEISE ZU VERÄNDERN, ZU ÜBERSETZEN, ZU
              DISASSEMBLIEREN ODER ZU DEKOMPILIEREN.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Eigentumsvorbehalt</h3>
            <p>
              Das Nutzungsrecht an der Software geht erst mit der vollständigen
              Zahlung des Kaufpreises auf den Lizenznehmer über.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Preise, Zahlungsbedingungen</h3>
            <p>
              Die Preise sind in Euro (EUR). Die Preise und Kosten verstehen
              sich zuzüglich der gesetzlichen MwSt. sofern nicht anders
              angegeben. Die Preise für die Nutzung der Softwareprodukte werden
              8 Tagen nach erbrachter Lieferung oder Leistung und Zugang der
              Rechnung fällig.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Gesetzesanwendung</h3>
            <p>
              Dieser Vertrag unterliegt der Gesetzgebung der Bundesrepublik
              Deutschland und ist so anzuwenden, als ob die betreffenden
              Rechtsgeschäfte in der Bundesrepublik Deutschland stattfänden.
              Sowohl der Lizenznehmer als auch der Lizenzgeber nehmen zur
              Kenntnis, dass das Abkommen der Vereinten Nationen, bezüglich der
              Verträge für den internationalen Verkauf von Waren (1980),
              ausdrücklich von der Anwendung auf diesen Vertrag ausgeschlossen
              ist.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Gerichtsstand, Erfüllungsort</h3>
            <p>
              Der Gerichtsstand für beide Teile in jeder Höhe ist das für
              Eschborn zuständige Amtsgericht Frankfurt am Main. Ist eine der
              vorstehenden Bestimmungen nach dem ABG-Gesetz unwirksam, so kann
              sie der durch diese Unwirksamkeit benachteiligte Teil durch die
              jetzt zulässige Regelung ersetzen, die den Zweck der unwirksamen
              Bestimmung am weitest gehenden erreicht. Der Erfüllungsort ist
              Frankfurt am Main. Mit der Installation der Software werden vom
              Lizenznehmer die AGB und Lizenzbedingungen vollständig anerkannt.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Haftungshinweis</h3>
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
              Haftung für die Inhalte externer Links. Für den Inhalt der
              verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </div>
          <div>
            <h3 className="text-2xl mb-1">Haftungsausschluss</h3>
            <p>
              Die Inhalte dieser Website werden unter Ausschluss jeglicher
              Gewährleistung zur Verfügung gestellt. Der Nutzer wird
              ausdrücklich darauf hingewiesen, dass die Website Tippfehler sowie
              falsche, unvollständige oder überholte Informationen enthalten
              kann. Die Nutzung der auf dieser Website zur Verfügung gestellten
              Inhalte erfolgt auf alleinige Gefahr des Nutzers. Wir übernehmen
              insbesondere keine Haftung für die Richtigkeit, Vollständigkeit
              oder Brauchbarkeit der auf dieser Website zu findenden
              Informationen für einen bestimmten Zweck. Ausdrücklich sind wir
              nicht verantwortlich, wenn der Nutzer im Vertrauen auf die
              Fehlerfreiheit und Vollständigkeit der Inhalte Handlungen vornimmt
              oder unterlässt und ihm infolgedessen Schäden entstehen. Falls die
              Nutzung dieser Website bzw. der auf ihr angebotenen Inhalte dazu
              führt, dass Sie Ihre Geräte oder Ihre Daten warten, reparieren,
              austauschen oder sonst wie korrigieren müssen, übernehmen wir
              hierfür keinerlei Kosten. Wir können auch nicht für entgangene
              Vorteile, Verträge oder sonstige unmittelbare oder mittelbare
              Schäden, die aus diesen Informationen entstehen können, haftbar
              gemacht werden. Wir arbeiten mit einem sehr leistungsfähigen
              Internet-Provider zusammen. Sollte es trotz aller technischen
              Sicherungsmaßnahmen doch einmal zu einem Netzausfall kommen,
              übernehmen wir hierfür keinerlei Verantwortung.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
